import { vars } from 'braid-design-system/css';

export const parseBulletPoints = (text: string): JSX.Element => {
  const lines = text.trim().split('\n');
  // Match common bullet characters at the start of a line with optional whitespace
  // Also match numbered lists like "1.", "2.", etc.
  const bulletRegex = /^[\s\t]*([•●○◦▪▫■□\-*])\s+/;

  let inList = false;
  let listItems: string[] = [];
  const result: Array<JSX.Element | string> = [];

  lines.forEach((line, index) => {
    const isBullet = bulletRegex.test(line);

    if (isBullet) {
      // Remove bullet and leading whitespace
      const cleanedLine = line.replace(bulletRegex, '').trim();
      if (cleanedLine) {
        listItems.push(cleanedLine);
        inList = true;
      }
    } else {
      // Not a bullet - flush any accumulated list items
      if (inList && listItems.length > 0) {
        result.push(
          <ul
            key={`list-${index}`}
            style={{
              marginTop: 0,
              marginBottom: 0,
              marginLeft: vars.space.medium,
              paddingLeft: 0,
            }}
          >
            {listItems.map((item, i) => (
              <li
                key={i}
                style={{
                  marginTop: vars.space.xxsmall,
                  marginBottom: vars.space.xxsmall,
                }}
              >
                {item}
              </li>
            ))}
          </ul>,
        );
        listItems = [];
        inList = false;
      }

      if (line.trim()) {
        result.push(
          <p
            key={`line-${index}`}
            style={{
              marginTop: index > 0 ? vars.space.xsmall : 0,
              marginBottom: index === lines.length - 1 ? 0 : vars.space.xsmall,
            }}
          >
            {line}
          </p>,
        );
      }
    }
  });

  // Flush any remaining list items at the end
  if (listItems.length > 0) {
    result.push(
      <ul
        key="list-end"
        style={{
          marginTop: 0,
          marginBottom: 0,
          marginLeft: vars.space.medium,
          paddingLeft: 0,
        }}
      >
        {listItems.map((item, i) => (
          <li
            key={i}
            style={{
              marginTop: vars.space.xxsmall,
              marginBottom: vars.space.xxsmall,
            }}
          >
            {item}
          </li>
        ))}
      </ul>,
    );
  }

  return <>{result}</>;
};
